import React from 'react';
import { Instagram, Check, Sparkles } from 'lucide-react';

const highlights = [
  'Personalised readings for career, marriage, finance and life direction',
  'Astrology, Tarot, Numerology and holistic guidance in one place',
  'Every reading prepared personally by Nitika — no automation',
  'Private and encrypted delivery over WhatsApp'
];

export const AboutSection = () => {
  return (
    <section className="py-16 sm:py-20 bg-gradient-to-b from-[#0A0000] to-[#1A0B0C]">
      <div className="container mx-auto px-4 max-w-5xl">
        <p className="text-[11px] tracking-[0.2em] uppercase text-[#D4AF37] text-center mb-3 font-medium">
          Meet Your Guide
        </p>
        <h2 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl text-center text-white mb-10 font-medium">
          About Nitika Bhola
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 items-center">
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_starlight-readings-1/artifacts/kaq8ldqa_70CFEB64-2E42-4215-8E19-DD5642367B64.png"
              alt="Nitika Bhola, Astrologer, Tarot Reader and Numerologist"
              className="w-full max-w-sm mx-auto rounded-2xl border border-[#D4AF37]/25 shadow-lg"
              loading="lazy"
            />
          </div>

          <div>
            <p className="text-[#E8DCC4] text-base leading-relaxed mb-4">
              <span className="text-[#D4AF37] font-semibold">Nitika Bhola</span> is a practising Astrologer, Tarot Reader, Numerologist and Spiritual Guide. Her work blends classical Vedic astrology with tarot, numerology and holistic healing to help you find clarity and direction.
            </p>
            <p className="text-[#A89B8C] text-sm sm:text-base leading-relaxed mb-6">
              Every consultation is prepared personally and delivered privately on WhatsApp. No automated readings, no templates, no guaranteed promises — just careful, respectful guidance.
            </p>

            <ul className="space-y-2.5">
              {highlights.map((h) => (
                <li key={h} className="flex items-start gap-2.5">
                  <Check className="w-4 h-4 text-[#D4AF37] flex-shrink-0 mt-1" strokeWidth={2} />
                  <span className="text-[#E8DCC4] text-sm leading-relaxed">{h}</span>
                </li>
              ))}
            </ul>

            <a
              href="https://www.instagram.com/nitikabhola_astro"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-7 inline-flex items-center gap-2 border border-[#D4AF37]/40 hover:border-[#D4AF37] text-[#F3E5AB] hover:text-white text-sm font-medium px-5 py-2.5 rounded-full transition-colors duration-200"
              data-testid="about-instagram-cta"
            >
              <Instagram className="w-4 h-4" />
              Follow Nitika on Instagram
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
